import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminLsaAssignments = {
  index: async(props) => {
    const { default: IndexPage } = await import('@/vue_widgets/admin/lsa/assignments/index.vue')
    createVueApp(IndexPage, { props })
  }
}
